import CreateNewFolderIcon from "@mui/icons-material/CreateNewFolder";
import JoinFullIcon from "@mui/icons-material/JoinFull";
import {
  Autocomplete,
  Avatar,
  Box,
  Button,
  Chip,
  CircularProgress,
  Divider,
  IconButton,
  MenuItem,
  Modal,
  Select,
  Tooltip
} from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { decode } from "base-64";
import { useFormik } from "formik";
import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import * as Yup from "yup";
import { api } from "../api";
import AuthContext from "../auth/AuthProvider";
import { fetchToken } from "../auth/Token";
import Header from "../components/Header";
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(2),
  borderStyle: 'groove',
  border: '3px',
  borderColor: 'grey',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.2)',
  marginTop: '10px',  
  marginBottom: '10px',
  minHeight: '50px',
  borderRadius: '10px'
}));

const Itemb = styled(Paper)(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(26, 32, 39, 0.5)"
      : "rgba(255, 255, 255, 0.2)",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  marginTop: "30px",
  borderRadius: "8px",
}));

const Association_kind = ({ society_id, setOpe }) => {
  const navigate = useNavigate();
  const { permissions } = useContext(AuthContext);
  const [apiResponse, setApiResponse] = useState([]);
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = React.useState({
    association_type: "",
    open_date: new Date(),
    society_id: society_id,
  });
  const handleInputChange = (event) => {
    const value = event.target.value;
    setFormData({
      ...formData,
      [event.target.name]: value,
    });
  };
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getAssociationKinds = async () => {
    try {
      await api
        .get(`/association/types/${society_id}`, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          setApiResponse(response.data?.types);
        });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAssociationKinds();
  }, []);

  const createAm = async (event) => {
    event.preventDefault();
    try {
      await api
        .post("/association/create/type", formData, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          toast.success(response.data);
          handleClose();
          getAssociationKinds();
          setFormData({
            association_type: "",
            open_date: new Date(),
            society_id: society_id,
          });
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleClick = (id) => {
    api
      .get(`/association/type/${id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        if (response.status === 200 && response.data) {
          navigate("/onekind/", {
            state: { responseInfo: response.data, society_id: society_id },
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  return (
    <Grid item xs={12} md={6}>
      <Item>
        <Typography
          sx={{ textAlign: "center" }}
          variant="h5"
          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
        >
          <b>Savings Groups Kinds</b>
        </Typography>
        {permissions && permissions.create_association_type === true ? (
          <Typography sx={{ m: 1 }} fontStyle="italic" variant="subtitle">
            <b>Create new savings group kind</b>
            <IconButton onClick={handleClickOpen}>
              <CreateNewFolderIcon />
            </IconButton>
          </Typography>
        ) : null}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            maxHeight: 400,
            overflowY: "scroll",
          }}
        >
          {apiResponse &&
            apiResponse.map((item) => (
              <Card
                sx={{
                  padding: "5px",
                  margin: 4,
                  backgroundColor: "#f8f9fa",
                  borderRadius: "15px",
                }}
              >
                <CardContent>
                  <Typography gutterBottom variant="h5" component="div">
                    <b style={{ color: "#000" }}>{item.association_type}</b>
                  </Typography>
                </CardContent>
                <CardActions>
                  <Chip
                    sx={{ m: 1, backgroundColor: "#1d3557", color: "#fff" }}
                    color="success"
                    key={item.associationtype_id}
                    label="Visit"
                    onClick={() => handleClick(item.associationtype_id)}
                  />
                </CardActions>
              </Card>
            ))}
        </Box>
      </Item>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Setup Savings Group Kind</DialogTitle>
        <DialogContent>
          <DialogContentText>
            You will be able to Register new Savings Groups after the setup.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="association_type"
            name="association_type"
            label="Name"
            onChange={handleInputChange}
            value={formData.association_type}
            type="text"
            fullWidth
            variant="outlined"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={createAm}>Create</Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

const Community = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const community_name = location.state && location.state.community_name;
  const cluster_name = location.state && location.state.cluster_name;
  const community_id = location.state && location.state.community_id;
  const society_name = location.state && location.state.society_name;
  const society_id = location.state && location.state.society_id;
  const [openn, setOpenn] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [modal_open, setModal_open] = useState(false);
  const [modal_open_edit, setModal_open_edit] = useState(false);
  const { permissions } = useContext(AuthContext);
  const [associations, setAssociations] = useState([]);
  const [community_details_associations, setCommunity_details_associations] =
    useState([]);
  const [association_id, setAssociation_id] = useState(null);
  const [kinds, setKinds] = useState([]);
  const [users, setUsers] = useState([]);
  const [members, setMembers] = useState([]);
  const [search_members, setSearch_Members] = useState("");
  const [savings, setSavings] = useState(null);
  const [new_name, setNew_Name] = useState("");
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [associationToDelete, setAssociationToDelete] = useState(null);
  const [personaInfo, setPersonaInfo] = useState([]);
  const handleDeleteClick = (association_id) => {
    setAssociationToDelete(association_id);
    setDeleteModalOpen(true);
  };

  const handleDeleteConfirm = () => {
    if (associationToDelete) {
      deleteAssociation(associationToDelete);
    }
    setDeleteModalOpen(false);
    setAssociationToDelete(null);
  };

  const handleDeleteCancel = () => {
    setDeleteModalOpen(false);
    setAssociationToDelete(null);
  };

  const deleteAssociation = (association_id) => {
    toast.promise(
      api
      .get(
        `/association/delete/association/${association_id}`,
        {
          headers: {
            Authorization: "Bearer " + fetchToken(),
            "Content-Type": "multipart/form-data",
          },
        }
      ),
      {
          loading: "Deleting Group And Related Contents...",
          success: (response) => {
              localStorage.removeItem(`associations_${society_id}`);
              localStorage.removeItem(`community_${community_id}`);
              fetch_associations();
              fetch_community_details();
              return response.data
          },
          error: (error) => {
              console.log(error);
              
              return 'Error, Please try again'
          }
      }
    )
  }



  const fetch_associations = () => {
    const cachedAssociations = localStorage.getItem(`associations_${society_id}`);
    
    if (cachedAssociations) {
      setAssociations(JSON.parse(cachedAssociations));
    } else {
      api
        .get(`/association/all/society/associations/${society_id}`, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          const associationsData = response.data?.all_yes;
          setAssociations(associationsData);
          localStorage.setItem(`associations_${society_id}`, JSON.stringify(associationsData));
        })
        .catch(function (error) {
          console.log(error);
        });
    }

    api
      .get("/users/su", {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setPersonaInfo(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  

  const fetch_community_members = () => {
    const cacheKey = `community_members_${community_id}_${search_members}`;
    const cachedMembers = localStorage.getItem(cacheKey);
  
    if (cachedMembers) {
      const parsedMembers = JSON.parse(cachedMembers);
      setMembers(parsedMembers);
    } else {
      const data = new FormData();
      data.append("search_members", search_members);
      data.append("community_id", community_id);
  
      api
        .post("/association/all/community/members", data, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          const membersData = response.data?.all_members;
          setMembers(membersData);
          localStorage.setItem(cacheKey, JSON.stringify(membersData));
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };
  

  const fetch_associations_kinds = () => {
    api
      .get(`/association/types/${society_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setKinds(response.data?.types);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  

  const fetch_community_details = () => {
    const cachedCommunityDetails = localStorage.getItem(`community_${community_id}`);
  
    if (cachedCommunityDetails) {
      const parsedData = JSON.parse(cachedCommunityDetails);
      setCommunity_details_associations(parsedData?.Associations);
      setSavings(parsedData?.Savings_total);
    } else {
      api
        .get(`/association/get/one/community/${community_id}`, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          const communityDetails = {
            Associations: response.data?.Associations,
            Savings_total: response.data?.Savings_total,
          };
          setCommunity_details_associations(communityDetails.Associations);
          setSavings(communityDetails.Savings_total);
          localStorage.setItem(`community_${community_id}`, JSON.stringify(communityDetails));
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };
  

  const fetchAssoData = () => {
    const cachedAssoData = localStorage.getItem("association_form_data");
  
    if (cachedAssoData) {
      const parsedAssoData = JSON.parse(cachedAssoData);
      setUsers(parsedAssoData[1]?.facilitator);
    } else {
      api
        .get("/association/form/data", {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          const assoData = response.data;
          setUsers(assoData[1]?.facilitator);
          localStorage.setItem("association_form_data", JSON.stringify(assoData));
        })
        .catch(function (error) {
          console.error(error);
        });
    }
  };
  

  const closeam = () => {
    setModal_open(false);
  };
  const closeam_edit = () => {
    setModal_open_edit(false);
  };

  const sec_style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 320,
    maxHeight: "80vh",
    overflowY: "auto",
    bgcolor: "background.paper",
    border: "1px solid #e7ecef",
    borderRadius: "7px",
    boxShadow: 24,
    p: 4,
  };

  const sec_style_edit = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 620,
    maxHeight: "80vh",
    overflowY: "auto",
    bgcolor: "background.paper",
    border: "1px solid #e7ecef",
    borderRadius: "7px",
    boxShadow: 24,
    p: 4,
  };

  const handleCloses = () => {
    setOpenn(false);
  };
  const handleOpen = () => {
    setOpenn(true);
  };

  const joinAssociation = (e) => {
    e.preventDefault();
    handleOpen();
    const data = new FormData();
    data.append("community_id", community_id);
    data.append("association_id", association_id);
    api
      .post("/association/join/association/community", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        toast.success(response.data);
        fetch_community_details();
        closeam();
        setAssociation_id();
        fetch_associations();
        fetch_community_members();
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        handleCloses();
      });
  };

  useEffect(() => {
    fetch_associations();
    fetch_community_details();
    fetch_associations_kinds();
    fetchAssoData();
    fetch_community_members();
  }, [community_id]);

  useEffect(() => {
    fetch_community_members();
  }, [search_members]);

  const updateName = () => {
    const data = new FormData()
    data.append('community_id', community_id)
    data.append('community_name', new_name)
    data.append('cluster_id', 0)
    api
      .post("/association/update/community", data,{
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        toast.promise(
            api.get(`/association/get/one/community/data/${community_id}`, {
              headers: {
                Authorization: "Bearer " + fetchToken(),
              },
            }),
            {
              loading: 'Updating community...',
              success: (response) => {
                navigate("/community", {
                  state: {
                    community_id: response.data?.community?.community_id,
                    cluster_name: response.data?.community?.cluster_name,
                    society_id: response.data?.community?.id,
                    society_name: response.data?.community?.society_name,
                    community_name: response.data?.community?.community_name,
                  },
                });
                return 'Successfully Updated';
              },
              error: 'Error loading updating community',
            }
          );
        setNew_Name('')
      })
      .catch(function (error) {
        console.log(error);
      });
  }


  const visitAssociations = (association_id) => {
    api
      .get(`/association/${association_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        navigate("/association/", { state: { responseData: response.data } });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const visitMember = ({ item }) => {
    navigate("/onemember/", {
      state: {
        Member_id: item.member_id,
        Fullname: `${item?.firstname} ${item?.lastname} ${item?.lastname}`,
      },
    });
  };

  const formik_edit = useFormik({
    initialValues: {
      association_name: "",
      association_type_id: 0,
      facilitator_userid: 0,
      association_email: "",
      staff_userid: 0,
      location: "",
      merchant_line: "",
    },
    validationSchema: Yup.object({
      association_name: Yup.string().required(
        "Savings Group name should not be empty"
      ),
      association_type_id: Yup.number().required(
        "Savings Group Kind can not be empty"
      ),
    }),
    onSubmit: (values) => {
      setLoading(true);
      const data = new FormData();
      data.append("association_name", values.association_name);
      data.append("association_type_id", values.association_type_id);
      data.append("facilitator_userid", values.facilitator_userid);
      data.append("association_email", values.association_email);
      data.append("staff_userid", values.staff_userid);
      data.append("community_id", community_id);
      data.append("location", values.location);
      data.append("merchant_line", values.merchant_line);

      api
        .post("/association/create", data, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          toast.success(response.data);
          fetch_associations();
          fetch_community_details();
          fetch_associations_kinds();
          fetchAssoData();
          closeam_edit();
          formik_edit.handleReset();
          fetch_community_members();
        })
        .catch(function (error) {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            const errorMessage = error.response.data.detail || 
                               error.response.data.message || 
                               "Failed to create association";
            
            toast.error(errorMessage);
            
            // Log detailed error for debugging
            console.error("Error details:", error.response.data);
          } else if (error.request) {
            // The request was made but no response was received
            toast.error("Network error - please try again");
            console.error("No response received:", error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            toast.error("An unexpected error occurred");
            console.error("Request setup error:", error.message);
          }
        })
        .finally(function () {
          setLoading(false);
        });
    },
  });

  const pic = (pic) => {
    const de = decode(pic);
    return `data:image/jpeg;base64,${btoa(de)}`;
  };

  const currencyFormat = new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
  });

  return (
    <div className="app">
      <main className="content">
        <Box sx={{ m: 5 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Header title="Community" />
          </Box>
          <Box>
            <Grid container spacing={1}>
              <Grid item xs={12} md={12}>
                <Tooltip
                    title={<>
                        <TextField 
                            size="small"
                            label="Edit"
                            value={new_name}
                            onChange={(event) => setNew_Name(event.target.value)}
                            variant="standard"
                        />
                        <Button variant="contained" onClick={updateName} size='medium'>
                            Save
                        </Button>
                        </>
                    }
                >
                    <Typography
                        sx={{ textAlign: "center", m: 1 }}
                        variant="h3"
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                        <b>{community_name}</b>
                    </Typography>
                </Tooltip>
                
                <Item>
                  <div>
                    <Chip
                      size="small"
                      label={
                        <Typography
                          variant="subtitle"
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          <b>Go to society</b>
                        </Typography>
                      }
                      sx={{
                        borderRadius: 2,
                        m: 1,
                        boxShadow:
                          "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                        backgroundColor: "#2b2d42",
                        color: "#fff",
                        "&:hover": {
                          boxShadow:
                            "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                          backgroundColor: "#14213d",
                        },
                      }}
                      onClick={() =>
                        navigate(`/allassociationKind/${society_id}`)
                      }
                    />
                  </div>
                  <div style={{ display: "flex", flexWrap: "wrap" }}>
                    <Card
                      sx={{
                        width: 180,
                        margin: 4,
                        backgroundColor: "#14213d",
                        borderRadius: "15px",
                      }}
                    >
                      <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                          <b style={{ color: "#fff" }}>Members</b>
                        </Typography>
                        <Typography
                          gutterBottom
                          variant="subtitle"
                          component="div"
                          fontStyle="italic"
                        >
                          <b style={{ color: "#fff" }}>{members.length}</b>
                        </Typography>
                      </CardContent>
                    </Card>

                    <Card
                      sx={{
                        width: 180,
                        margin: 4,
                        backgroundColor: "#14213d",
                        borderRadius: "15px",
                      }}
                    >
                      <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                          <b style={{ color: "#fff" }}>Savings Group</b>
                        </Typography>
                        <Typography
                          gutterBottom
                          variant="subtitle"
                          component="div"
                          fontStyle="italic"
                        >
                          <b style={{ color: "#fff" }}>
                            {community_details_associations.length}
                          </b>
                        </Typography>
                      </CardContent>
                    </Card>

                    <Card
                      sx={{
                        width: 180,
                        margin: 4,
                        backgroundColor: "#14213d",
                        borderRadius: "15px",
                      }}
                    >
                      <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                          <b style={{ color: "#fff" }}>
                            Current Savings Balance
                          </b>
                        </Typography>
                        <Typography gutterBottom variant="h5" component="div">
                          <b style={{ color: "#fff" }}>
                            {currencyFormat.format(savings)}
                          </b>
                        </Typography>
                      </CardContent>
                    </Card>

                    <Card
                      sx={{
                        width: 180,
                        margin: 4,
                        backgroundColor: "#14213d",
                        borderRadius: "15px",
                      }}
                    >
                      <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                          <b style={{ color: "#fff" }}>Loans Disbursed</b>
                        </Typography>
                        <Typography gutterBottom variant="h5" component="div">
                          <b style={{ color: "#fff" }}>...</b>
                        </Typography>
                      </CardContent>
                    </Card>

                    <Card
                      sx={{
                        width: 180,
                        margin: 4,
                        backgroundColor: "#14213d",
                        borderRadius: "15px",
                      }}
                    >
                      <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                          <b style={{ color: "#fff" }}>Popular Commodity</b>
                        </Typography>
                        <Typography gutterBottom variant="h5" component="div">
                          <b style={{ color: "#fff" }}>...</b>
                        </Typography>
                      </CardContent>
                    </Card>
                  </div>
                </Item>
              </Grid>

              <Grid item xs={12} md={6}>
                <Item>
                  <div>
                    <Typography
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      variant="h6"
                    >
                      Society: <b>{society_name}</b>
                    </Typography>
                  </div>
                  <TextField
                    size="small"
                    fullWidth
                    label="Search Member..."
                    name="search_members"
                    value={search_members}
                    onChange={(e) => setSearch_Members(e.target.value)}
                    sx={{
                      borderRadius: 5,
                      borderStyle: "none",
                      textDecoration: "none",
                      backgroundColor: "#fff",
                      mb: 5,
                    }}
                  />
                  <Box
                    sx={{
                      display: "block",
                      maxHeight: 400,
                      overflowY: "scroll",
                    }}
                  >
                    <div style={{ display: "block", marginTop: 1 }}>
                      {members &&
                        members.map((item) => (
                          <>
                            <div
                              key={item.member_id}
                              style={{ margin: 5, display: "flex" }}
                            >
                              <Avatar
                                sx={{ width: 65, height: 65 }}
                                alt={item.member_name}
                                src={pic(item.memberImage)}
                              />
                              <div style={{ display: "block" }}>
                                <Typography
                                  variant="body1"
                                  fontStyle="normal"
                                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                >
                                  <b>{`${item?.firstname} ${
                                    item.middlename ? item.middlename : ""
                                  } ${item?.lastname ? item.lastname : ""}`}</b>
                                </Typography>
                                <Chip
                                  sx={{
                                    m: 1,
                                    backgroundColor: "#1d3557",
                                    color: "#fff",
                                  }}
                                  color="success"
                                  key={item.member_id}
                                  label="Visit passbook"
                                  onClick={() => visitMember({ item })}
                                />
                              </div>
                            </div>
                            <Divider variant="middle" />
                          </>
                        ))}
                    </div>
                  </Box>
                </Item>
              </Grid>

              <Association_kind society_id={society_id} />

              <Grid item xs={12} md={12}>
                <Item>
                  <Typography
                    sx={{ textAlign: "center" }}
                    variant="h5"
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>Savings Groups in community</b>
                  </Typography>
                  <Typography
                    sx={{ m: 1 }}
                    fontStyle="italic"
                    variant="subtitle"
                  >
                    <b>Add Savings Group to Community</b>
                    <IconButton onClick={() => setModal_open(true)}>
                      <JoinFullIcon />
                    </IconButton>
                  </Typography>
                  {permissions && permissions.create_association === true ? (
                    <Typography
                      sx={{ m: 1 }}
                      fontStyle="italic"
                      variant="subtitle"
                    >
                      <b>Create new savings group</b>
                      <IconButton onClick={() => setModal_open_edit(true)}>
                        <CreateNewFolderIcon />
                      </IconButton>
                    </Typography>
                  ) : null}
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      maxHeight: 450,
                      overflowY: "scroll",
                    }}
                  >
                    {community_details_associations[0]
                      ? community_details_associations.map((item) => (
                          <Card
                            sx={{
                              padding: "5px",
                              margin: 4,
                              borderRadius: "15px",
                            }}
                          >
                            
                            <CardContent>
                              <Typography
                                gutterBottom
                                variant="h5"
                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                              >
                                <b>
                                  {item.association_name}
                                </b>
                              </Typography>
                            </CardContent>
                            <CardActions>
                            {personaInfo?.role_name === 'Administrator'?
                                <Button
                                    size="small"
                                    color="error"
                                    variant="contained"
                                    sx={{
                                    borderRadius: 2,
                                    mr: 'auto',
                                    boxShadow:
                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                    "&:hover": {
                                        boxShadow:
                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                        backgroundColor: "#14213d",
                                    },
                                    }}
                                    onClick={() => handleDeleteClick(item.association_id)}
                                >
                                    <DeleteRoundedIcon />
                                </Button>
                                :null}
                                <Button
                                    size="small"
                                    color="success"
                                    variant="contained"
                                    sx={{
                                    borderRadius: 2,
                                    mr: 'auto',
                                    boxShadow:
                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                    "&:hover": {
                                        boxShadow:
                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                        backgroundColor: "#14213d",
                                    },
                                    }}
                                    onClick={() => visitAssociations(item.association_id)}
                                >
                                    <Typography
                                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                    >
                                        <b>View</b>
                                    </Typography>
                                </Button>
                              
                            </CardActions>
                          </Card>
                        ))
                      : "No Savings Groups Found!"}
                  </Box>
                </Item>
              </Grid>
            </Grid>

            <Modal
              open={modal_open_edit}
              onClose={closeam_edit}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={sec_style_edit}>
                <Typography sx={{ textAlign: "center" }} fontStyle="oblique">
                  <b>Create Savings Group</b>
                </Typography>
                <form onSubmit={formik_edit.handleSubmit}>
                  <div style={{ margin: "5px" }}>
                    <TextField
                      size="small"
                      value={formik_edit.values.association_name}
                      name="association_name"
                      onChange={formik_edit.handleChange}
                      onBlur={formik_edit.handleBlur}
                      error={
                        formik_edit.touched.association_name &&
                        Boolean(formik_edit.errors.association_name)
                      }
                      helperText={
                        formik_edit.touched.association_name &&
                        formik_edit.errors.association_name
                      }
                      sx={{ m: 1 }}
                      variant="outlined"
                      label="Savings Group Name"
                    />
                    <TextField
                      size="small"
                      value={formik_edit.values.association_email}
                      name="association_email"
                      onChange={formik_edit.handleChange}
                      sx={{ m: 1 }}
                      variant="outlined"
                      label="Savings Group Email(optional)"
                    />
                    
                    <TextField
                      size="small"
                      value={formik_edit.values.merchant_line}
                      name="merchant_line"
                      onChange={formik_edit.handleChange}
                      sx={{ m: 1 }}
                      variant="outlined"
                      label="Merchant Line(optional)"
                    />
                    
                    <TextField
                      size="small"
                      value={formik_edit.values.location}
                      name="location"
                      onChange={formik_edit.handleChange}
                      sx={{ m: 1 }}
                      variant="outlined"
                      label="Location(link)"
                    />
                    <Select
                      required
                      size="small"
                      value={formik_edit.values.association_type_id}
                      name="association_type_id"
                      onChange={formik_edit.handleChange}
                      sx={{ m: 1 }}
                      variant="outlined"
                      onBlur={formik_edit.handleBlur}
                      error={
                        formik_edit.touched.association_type_id &&
                        Boolean(formik_edit.errors.association_type_id)
                      }
                      helperText={
                        formik_edit.touched.association_type_id &&
                        formik_edit.errors.association_type_id
                      }
                    >
                      <MenuItem key={0} value={0}>
                        Select Kind
                      </MenuItem>
                      {kinds &&
                        kinds.map((item) => (
                          <MenuItem
                            key={item.associationtype_id}
                            value={item.associationtype_id}
                          >
                            {item.association_type}
                          </MenuItem>
                        ))}
                    </Select>
                    <Select
                      required
                      size="small"
                      value={formik_edit.values.facilitator_userid}
                      name="facilitator_userid"
                      onChange={formik_edit.handleChange}
                      sx={{ m: 1 }}
                      variant="outlined"
                    >
                      <MenuItem key={0} value={0}>
                        Select Facilitator
                      </MenuItem>
                      {users.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.username}
                        </MenuItem>
                      ))}
                    </Select>
                    <Select
                      required
                      size="small"
                      value={formik_edit.values.staff_userid}
                      name="staff_userid"
                      onChange={formik_edit.handleChange}
                      sx={{ m: 1 }}
                      variant="outlined"
                    >
                      <MenuItem key={0} value={0}>
                        Select Staff
                      </MenuItem>
                      {users.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.username}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>

                  <div style={{ display: "flex" }}>
                    <Button
                      sx={{ m: 1 }}
                      size="small"
                      variant="contained"
                      color="error"
                      onClick={closeam_edit}
                    >
                      Cancel
                    </Button>
                    <Button
                      sx={{ m: 1 }}
                      type="submit"
                      size="small"
                      variant="contained"
                      color="success"
                      disabled={loading}
                    >
                      {loading === true ? (
                        <CircularProgress color="info" size="20px" />
                      ) : (
                        "Create"
                      )}
                    </Button>
                  </div>
                </form>
              </Box>
            </Modal>

            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={openn}
              onClick={handleCloses}
            >
              <CircularProgress color="inherit" />
            </Backdrop>

            <Dialog open={modal_open} onClose={closeam} maxWidth="md">
              <DialogTitle>
                <b>Join savings group to community</b>
                <p>
                Savings Groups in <b>{society_name}</b>
                </p>
              </DialogTitle>
              <form onSubmit={joinAssociation}>
                <DialogContent>
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={associations}
                    getOptionLabel={(option) => option.association_name}
                    isOptionEqualToValue={(option, value) =>
                      option.association_id === value.association_id
                    }
                    onChange={(event, value) =>
                      setAssociation_id(value.association_id)
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Savings Group"
                        size="small"
                      />
                    )}
                  />
                </DialogContent>

                <DialogActions>
                  <div style={{ display: "flex" }}>
                    <Button
                      sx={{ m: 1 }}
                      size="small"
                      variant="contained"
                      color="error"
                      onClick={closeam}
                    >
                      Cancel
                    </Button>
                    <Button
                      sx={{ m: 1 }}
                      type="submit"
                      size="small"
                      variant="contained"
                      color="success"
                    >
                      Join
                    </Button>
                  </div>
                </DialogActions>
              </form>
            </Dialog>

          </Box>
          {/* Delete Confirmation Modal */}
          <Dialog
            open={deleteModalOpen}
            onClose={handleDeleteCancel}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {"Confirm Deletion"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Are you sure you want to delete this savings group? This action cannot be undone and will permanently delete all associated data including transactions and member records.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleDeleteCancel} color="primary">
                Cancel
              </Button>
              <Button 
                onClick={handleDeleteConfirm} 
                color="error"
                autoFocus
              >
                Delete
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      </main>
    </div>
  );
};

export default Community;
